export default `
<svg
  aria-hidden="true"
  aria-label="table"
  width="24"
  height="24"
  viewBox="0 0 640 640"
  fill="none"
>
  <path
    d="M352 224L352 320L480 320L480 224L352 224zM288 224L160 224L160 320L288 320L288 224zM96 384L96 160C96 124.7 124.7 96 160 96L480 96C515.3 96 544 124.7 544 160L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 384zM480 384L352 384L352 480L480 480L480 384zM288 480L288 384L160 384L160 480L288 480z"
    fill="currentColor"
  />
</svg>`;
